<template>
  <div class="TableSearchField input-group-sm">
    <input v-model.trim="search"
      class="form-control"
      :placeholder="placeholder"

      style="width: 100%"
    />
  </div>
</template>

<script>

export default {
  props: {
    value: [String, Object, Number],
    placeholder: {
      type: String,
      default: "Zoeken",
      required: false,
    },
  },
  data() {
    return {
      search: this.value || "",
      sort: "asc",
    }
  },
  watch: {
    value(val) {
      this.search = val
    },
    search(val) {
      this.$emit("input", val)
    },
  },
}

</script>

<style scoped>

.input-group-sm {
  position: relative;
  display: flex;
}

input {
  border: 1px solid #bebfc1;
}

</style>
